import React, { useState } from "react";
import { AmeaInfrastructureFiltersContext } from "./context";

import {
  infrastructureCategoryFilters,
  infrastructureTypeFilters,
} from "../components/Map/utils";

const initialValue = {
  categories: infrastructureCategoryFilters,
  types: infrastructureTypeFilters,
};

const AmeaInfrastructureFiltersProvider = ({ children }) => {
  const [infrastructureFiltersData, setInfrastructureFiltersData] =
    useState(initialValue);

  return (
    <AmeaInfrastructureFiltersContext.Provider
      value={{
        get: infrastructureFiltersData,
        set: setInfrastructureFiltersData,
      }}
    >
      {children}
    </AmeaInfrastructureFiltersContext.Provider>
  );
};

export default AmeaInfrastructureFiltersProvider;
